export default __webpack_public_path__ + "static/media/play-circle-green.183f56d8.svg";